import { useEffect, useState } from "react";

const TRAY_DEVICE_URL = "http://localhost:8535/device-id";
const TRAY_R2_BASE = "https://pub-d5b28d4fdad840e9ad4bd5846a4eabae.r2.dev";
const TRAY_MANIFEST_URL = `${TRAY_R2_BASE}/release.json`;

export interface TrayAvailability {
    checking: boolean;
    available: boolean;
    downloadUrl: string | null;
    version: string | null;
}

export const useTrayAppAvailability = (enabled: boolean): TrayAvailability => {
    const [checking, setChecking] = useState(true);
    const [available, setAvailable] = useState(true);
    const [downloadUrl, setDownloadUrl] = useState<string | null>(null);
    const [version, setVersion] = useState<string | null>(null);

    useEffect(() => {
        if (!enabled) {
            setChecking(false);
            return;
        }

        const run = async () => {
            try {
                const controller = new AbortController();
                const timeout = setTimeout(() => controller.abort(), 3000);
                await fetch(TRAY_DEVICE_URL, { signal: controller.signal });
                clearTimeout(timeout);
                setAvailable(true);
            } catch {
                setAvailable(false);
                try {
                    const res = await fetch(TRAY_MANIFEST_URL);
                    if (res.ok) {
                        const manifest = await res.json();
                        const v: string = manifest.version ?? "";
                        setVersion(v);
                        setDownloadUrl(`${TRAY_R2_BASE}/PrestoTray-${v}.zip`);
                        return;
                    }
                } catch {
                    // CORS or network — use latest fallback
                }
                setDownloadUrl(`${TRAY_R2_BASE}/PrestoTray-latest.zip`);
            } finally {
                setChecking(false);
            }
        };

        run();
    }, [enabled]);

    return { checking, available, downloadUrl, version };
};
